import DownloadIcon from "@/assets/images/icons2/icon--download.svg?component";
import type { PatientConsent, UUID } from "@/core/types";
import { Tooltip2 } from "@/ui2/molecules/Tooltip";
import { viewPatientPolicyFile } from "@/utils/fileUtil";

type DownloadButtonProps = {
  patientId: UUID;
  reportKey: PatientConsent["user_file_report_key"];
};

export function DownloadButton({ patientId, reportKey }: DownloadButtonProps) {
  if (!reportKey) return null;

  return (
    <div className="tw:row-span-2 tw:lg:!mr-15">
      <Tooltip2
        text="Download Consent"
        triggerProps={{
          onPress: () => viewPatientPolicyFile(patientId, reportKey, "ADVANCED_CARE_PROGRAM"),
        }}
      >
        <span className="tw:!ml-0 tw:w-auto tw:lg2:p-1">
          <b className="tw:mr-1 tw:lg2:hidden">Download: </b>
          <DownloadIcon />
        </span>
      </Tooltip2>
    </div>
  );
}
